import ReactDOM from 'react-dom';
import App from './App';
import MyProvider from './context/MyProvider';
import './index.css';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <MyProvider>
    <App />
  </MyProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
